import {
  GET_CSV_FILE,GET_CSV_FILE_SUCCESS,GET_CSV_FILE_FAILED, IMPORT_MIGRATION_DATA, IMPORT_MIGRATION_DATA_SUCCESS, IMPORT_MIGRATION_DATA_FAILED, FIELD_MAP_DATA, FIELD_MAP_DATA_SUCCESS, FIELD_MAP_DATA_FAILED, BULK_IMPORT_MIGRATION_DATA_SUCCESS, BULK_IMPORT_MIGRATION_DATA_FAILED, BULK_IMPORT_MIGRATION_DATA, GET_MIGRATION_IDS, GET_MIGRATION_STATUS, GET_MIGRATION_STATUS_SUCCESS, GET_MIGRATION_STATUS_FAILED, GET_MIGRATION_IDS_SUCCESS, GET_MIGRATION_IDS_FAILED
} from "./actionTypes"

const initialState = {
  sampleCsvFile:null,
  migrationLoading:false,
  importSuccess:null,
  importError:null,
  fieldMapSuccess:null,
  fieldMapFailed:null,
  bulkSuccess:null,
  bulkFailed:null,
  ids:null,
  idsFailed:null,
  statusData:null,
  statusError:null
}


const migrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CSV_FILE:
      state = {
        ...state,
        migrationLoading: false,
        sampleCsvFile:null,
      }
      break
    case GET_CSV_FILE_SUCCESS:
      state = {
        ...state,
        migrationLoading: false,
        sampleCsvFile:action.payload
      }
      break
    case GET_CSV_FILE_FAILED:
      state = { ...state, migrationLoading: false,sampleCsvFile:null }
      break
      case IMPORT_MIGRATION_DATA:
          state = {
            ...state,
            migrationLoading: true,
            importSuccess:null,
  importError:null
          }
          break
        case IMPORT_MIGRATION_DATA_SUCCESS:
          state = {
            ...state,
            migrationLoading: false,
            importSuccess:action.payload,
  importError:null
          }
          break
        case IMPORT_MIGRATION_DATA_FAILED:
          state = { ...state, migrationLoading: false,importSuccess:null,
              importError:action.payload }
          break
          case FIELD_MAP_DATA:
            state = {
              ...state,
              migrationLoading: true,
              fieldMapSuccess:null,
              fieldMapFailed:null
            }
            break
          case FIELD_MAP_DATA_SUCCESS:
            state = {
              ...state,
              migrationLoading: false,
              fieldMapSuccess:action.payload,
              fieldMapFailed:null
            }
            break
          case FIELD_MAP_DATA_FAILED:
            state = { ...state, migrationLoading: false,
              fieldMapSuccess:null,
              fieldMapFailed:action.payload
             }
            break  
            case BULK_IMPORT_MIGRATION_DATA:
              state = {
                ...state,
                migrationLoading: true,
                bulkSuccess:null,
                bulkFailed:null
              }
              break
            case BULK_IMPORT_MIGRATION_DATA_SUCCESS:
              state = {
                ...state,
                migrationLoading: false,
                bulkSuccess:action.payload,
                bulkFailed:null
              }
              break
            case BULK_IMPORT_MIGRATION_DATA_FAILED:
              state = { ...state, migrationLoading: false,bulkSuccess:null,
                bulkFailed:action.payload }
              break  
              case GET_MIGRATION_IDS:
                state = {
                  ...state,
                  migrationLoading: true,
                  ids:null,
                  idsFailed:null
                }
                break
                case GET_MIGRATION_IDS_SUCCESS:
                state = {
                  ...state,
                  migrationLoading: false,
                  ids:action.payload,
                  idsFailed:null
                }
                break
                case GET_MIGRATION_IDS_FAILED:
                state = {
                  ...state,
                  migrationLoading: false,
                  ids:null,
                  idsFailed:action.payload
                }
                break
              case BULK_IMPORT_MIGRATION_DATA_SUCCESS:
                state = {
                  ...state,
                  migrationLoading: false,
                  ids:action.payload,
                  idsFailed:null
                }
                break
              case BULK_IMPORT_MIGRATION_DATA_FAILED:
                state = { ...state,
                  ids:null,
                  idsFailed:action.payload
                 }
                break   
                case GET_MIGRATION_STATUS:
                  state = {
                    ...state,
                    migrationLoading: false,
                    statusData:null,
  statusError:null
                  }
                  break
                case GET_MIGRATION_STATUS_SUCCESS:
                  state = {
                    ...state,
                    migrationLoading: false,
                    statusData:action.payload,
                    statusError:null
                  }
                  break
                case GET_MIGRATION_STATUS_FAILED:
                  state = { ...state, migrationLoading: false, statusData:null,
                    statusError:action.payload }
                  break      
   
    default:
      state = { ...state }
      break
  }
  return state
}

export default migrationReducer
